import axios from 'axios';
import i18n from '@/i18n';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8002',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Send cookies cross-origin (session_token from launcher)
});

// Request interceptor: automatically append current language to every API request.
// Backend uses ?lang=ru|en to localize animal/category names, descriptions and facts.
api.interceptors.request.use((config) => {
  const lang = i18n.language?.startsWith('en') ? 'en' : 'ru';
  config.params = { lang, ...config.params };
  return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default api;
